import get from 'lodash/get';

export const logoutActions = () => {
    localStorage.clear();
    window.location.replace('/login');
};

export const getSessionLocalStorage = () =>
    typeof localStorage.getItem('session') !== 'undefined'
        ? JSON.parse(localStorage.getItem('session'))
        : {};

export const getGroupsLocalStorage = () =>
    typeof localStorage.getItem('groups') !== 'undefined'
        ? JSON.parse(localStorage.getItem('groups'))
        : [];

export const getUserPermits = () => {
    const groups = getGroupsLocalStorage();
    const sessionGroups =
        groups && groups !== 'undefined' && Array.isArray(groups) ? groups : [];

    const groupsFiltered = sessionGroups.filter((item) => item.is_enabled);

    return groupsFiltered.map((group) => group.group_id);
};

export const getToken = () => localStorage.getItem('token');

export const getIsGuess = () => {
    return !localStorage.getItem('token');
};

export const getCountryCurrencyIso = () => {
    const currency = getCountryCurrency();
    return get(currency, 'abbreviation', 'USD');
};

export const getNumberFormatPartsByCountryCurrency = () =>
    new Intl.NumberFormat(getCountryCurrencyLocale(), {
        style: 'currency',
        currency: getCountryCurrencyIso(),
    }).formatToParts(Math.PI * 10000);

export const getCountryCurrencyDecimalSeparator = () => {
    const parts = getNumberFormatPartsByCountryCurrency();
    const decimalSeparator = parts.find((p) => p.type === 'decimal');
    if (decimalSeparator) return decimalSeparator.value;
    return '.';
};

export const getCountryCurrencyThousandSeparator = () => {
    const parts = getNumberFormatPartsByCountryCurrency();
    const thousandSeparator = parts.find((p) => p.type === 'group');
    if (thousandSeparator) return thousandSeparator.value;
    return ',';
};

export const getCountryCurrency = () => {
    const session = getSessionLocalStorage();
    return get(session, 'currency_company_locale', {});
};

export const getCountryCurrencyLocale = () => {
    const currency = getCountryCurrency();
    return get(currency, 'locale', 'en-US').replace(/_/g, '-');
};
